module.exports = __webpack_public_path__ + "img/managed.2e79d4b.png";